import React, { useContext, useEffect, useState } from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'

import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { getUserByID } from '../../api/auth';
import { NotificationShimmer } from '../common/Shimmer';


export default function LikeComponent({ data, user }) {
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory()
    const [userData, setUserData] = useState({})
    const [dataLoading, setDataLoading] = useState(true);


    const fetchUserData = async () => {
        const res = await getUserByID(user)
        setUserData(res);
        setDataLoading(false)
    }

    useEffect(() => {
        setDataLoading(true)
        fetchUserData()
    }, [])


    const getTimeAgo = (time) => {
        try {
            return moment(new Date((time.seconds + time.nanoseconds * 10 ** -9) * 1000)).fromNow()
        } catch (e) { }
    }


    const openUserProfile = () => {
        history.push(`/user/${userData.username}`)

    }

    const openPost = () => {
        if (data.type == 1) {
            history.push(`/post/${data.post}/img`)
        } else {
            history.push(`/post/${data.post}/mp4`)
        }
    }

    return (
        <div>
            {
                dataLoading ?
                <NotificationShimmer /> :
                <div className="notification-like-component">
                    <div className="notification-like-c-left">
                        <div>
                            <img onClick={openUserProfile} src={userData.image} />
                            <div>
                                <h1 onClick={openUserProfile} className={isDark ? 'dark-notification' : ''}>{userData.username}</h1>
                                <h2>{data.text}</h2>
                                <p>{getTimeAgo(data.timestamp)}</p>
                            </div>
                        </div>
                    </div>
                    <div className="notification-like-c-right">
                        <img onClick={openPost} src={data.placeholder} />
                    </div>
                </div>
            }
        </div>
    )
}
